import React from "react";
import { inject, observer } from "mobx-react";
import Language from "../language/language";
import { Button, Form, Input } from "antd";

import "./stylesheets/joinInTeam.scss";

const FormItem = Form.Item;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

@inject("languageStore", "authStore", "teamStore", "gameStore")
@observer
class JoinInTeam extends React.Component {
  joinInTeam = e => {
    e.preventDefault();
    let lang = this.props.languageStore.lang;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // 检验邀请码是否正确
        this.props.teamStore
          .searchTeam(values.invitationCode)
          .then(() => {
            if (this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.id) {
              if (this.props.teamStore.joinInTeamInfo.teamIsWrong) {
                let keys = [
                  this.props.teamStore.joinInTeamInfo.gevent &&
                    this.props.teamStore.joinInTeamInfo.gevent.titleUuidI18n
                ];
                this.props.form.setFields({
                  invitationCode: {
                    value: values.invitationCode,
                    errors: [
                      new Error(
                        this.props.languageStore.getResource(lang, "WRONG_INVITATION_CODE", keys)
                      )
                    ]
                  }
                });
              } else {
                this.props.authStore.closeJoinOrCreateModal();
              }
            } else {
              this.props.form.setFields({
                invitationCode: {
                  value: values.invitationCode,
                  errors: [
                    new Error(this.props.languageStore.getResource(lang, "INVALID_INVITATION_CODE"))
                  ]
                }
              });
            }
          })
          .finally(() => {});
      }
    });
  };
  componentDidMount() {
    // this.props.form.validateFields();
    this.props.form.setFields({
      invitationCode: {
        value: ""
      }
    });
  }
  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    return (
      <div className="join-in-team">
        <Form onSubmit={this.joinInTeam} className="join-in-team-form">
          <FormItem validateStatus={"error"}>
            {getFieldDecorator("invitationCode", {
              rules: [{ required: true, message: <Language resource="ENTER_INVITATION_TIP" /> }]
            })(<Input></Input>)}
          </FormItem>
          <div className="description">
            <Language resource="INVITATION_CODE_INFO"></Language>
          </div>
          <FormItem>
            <Button
              disabled={hasErrors(getFieldsError())}
              type="primary"
              htmlType="submit"
              className="button"
            >
              <Language resource="JOIN_IN_TEAM" />
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const JoinInTeamForm = Form.create()(JoinInTeam);

export default JoinInTeamForm;



// WEBPACK FOOTER //
// ./src/components/registrationCenter/joinInTeam.js